import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import LoginScreen from './LoginScreen';
import App from '../App';
import HomeView from './HomeView';

const AppShell = () => {
    const { currentUser, isMasterMode } = useAuth();

    // Check for share link in URL: ?share=playbookId or ?play=playbookId:playId
    const urlParams = new URLSearchParams(window.location.search);
    const shareId = urlParams.get('share');
    const playLinkId = urlParams.get('play'); // Format: playbookId:playId

    let initialPlaybookId = shareId;
    let initialPlayId = null;

    if (playLinkId && playLinkId.includes(':')) {
        const [pbId, pId] = playLinkId.split(':');
        initialPlaybookId = pbId;
        initialPlayId = pId;
    }

    const [activePlaybookId, setActivePlaybookId] = useState(initialPlaybookId);

    // Sync state if URL changes (e.g. clicking a different link while app is open)
    React.useEffect(() => {
        if (initialPlaybookId) {
            setActivePlaybookId(initialPlaybookId);
        }
    }, [initialPlaybookId]);

    // If not logged in and not in Master Mode AND no share link, show Login
    if (!currentUser && !isMasterMode && !initialPlaybookId) {
        return <LoginScreen />;
    }

    // If we have a selected playbook (or in Master Mode), show the Editor (App.js)
    // Note: For Master Mode, we might just stay in the Editor or show Home with Local Portfolio option.
    // For now, if in Master Mode, let's go to Home so they can choose.
    if (activePlaybookId) {
        // Public share if accessing via link and not logged in (or explicitly a share link)
        // If logged in but accessing a link, we still treat as readonly if not a collaborator (handled inside App)
        // But for "forceReadOnly" prop, we generally set true if not logged in.
        const isPublicShare = (shareId || playLinkId) && !currentUser;

        // SINGLE PLAY MODE: If they come in via a ?play= link, restrict them to JUST that play.
        const isSinglePlayMode = !!playLinkId;

        return (
            <App
                playbookId={activePlaybookId}
                initialPlayId={initialPlayId}
                isReadOnly={isPublicShare}
                isSinglePlayMode={isSinglePlayMode}
                onExit={() => {
                    // Clear share param and state
                    window.history.replaceState({}, document.title, "/");
                    setActivePlaybookId(null);
                }}
            />
        );
    }

    return (
        <HomeView
            onSelectPlaybook={(id) => setActivePlaybookId(id)}
        />
    );
};

export default AppShell;
